// src/core/Components/ScrollToTop.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        // Scroll to top of page on route change
        window.scrollTo(0, 0);
    }, [pathname]);
    return null; // This component doesn't render anything
}
